import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, useLocation } from 'react-router-dom';

// ==============================================
// 以后加单元 / 游戏 只改这里！
// ==============================================
const unitList = [
  {
    unitId: 1,
    unitTitle: "1. 四则运算",
    unitColor: "bg-primary/20",
    unitIcon: "fa-calculator",
    games: [
      { gameId: "24", gameTitle: "1.24点数学闯关游戏", gamePath: "/game/24", gameSrc: "/1.第1单元-四则运算/1.24点数学闯关游戏.html", isDone: true },
      { gameId: "multiply", gameTitle: "1.2 乘除法的意义", gamePath: "/game/multiply", gameSrc: "", isDone: false },
      { gameId: "bracket", gameTitle: "1.3 括号的运用", gamePath: "/game/bracket", gameSrc: "", isDone: false },
    ],
  },
  {
    unitId: 2,
    unitTitle: "2. 观察物体（二）",
    unitColor: "bg-secondary/20",
    unitIcon: "fa-eye",
    games: [
      { gameId: "cube", gameTitle: "2.1 正方体搭建三视图", gamePath: "/game/cube", gameSrc: "/2.第2单元-观察物体/1.正方体搭建三视图.html", isDone: true },
      { gameId: "3dview", gameTitle: "2.2 观察立体图形", gamePath: "/game/3dview", gameSrc: "", isDone: false },
    ],
  },
  {
    unitId: 3,
    unitTitle: "3. 运算定律",
    unitColor: "bg-accent/20",
    unitIcon: "fa-exchange",
    games: [
      { gameId: "add", gameTitle: "3.1 加法运算定律", gamePath: "", gameSrc: "", isDone: false },
    ],
  },
  {
    unitId: 4,
    unitTitle: "4. 小数的意义和性质",
    unitColor: "bg-green-500/20",
    unitIcon: "fa-sort-numeric-asc",
    games: [],
  },
  {
    unitId: 5,
    unitTitle: "5. 三角形",
    unitColor: "bg-purple-500/20",
    unitIcon: "fa-caret-down",
    games: [],
  },
  {
    unitId: 6,
    unitTitle: "6. 小数加减法",
    unitColor: "bg-red-500/20",
    unitIcon: "fa-plus",
    games: [],
  },
  {
    unitId: 7,
    unitTitle: "7. 图形的运动",
    unitColor: "bg-teal-500/20",
    unitIcon: "fa-arrows-alt",
    games: [],
  },
  {
    unitId: 8,
    unitTitle: "8. 平均数与条形统计图",
    unitColor: "bg-indigo-500/20",
    unitIcon: "fa-bar-chart",
    games: [],
  },
  {
    unitId: 9,
    unitTitle: "9. 数学广角 - 鸡兔同笼",
    unitColor: "bg-gray-500/20",
    unitIcon: "fa-paw",
    games: [],
  },
];

export default function App() {
  return (
    <Router>
      <div className="min-h-screen bg-light bg-pattern">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          {unitList.flatMap(unit =>
            unit.games.map(game => (
              game.isDone && <Route key={game.gameId} path={game.gamePath} element={<GamePage src={game.gameSrc} />} />
            ))
          )}
        </Routes>
      </div>
    </Router>
  );
}

// 导航栏
function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const isGame = location.pathname.startsWith("/game/");
  return (
    <header className="bg-primary text-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        {isGame && <button onClick={() => navigate(-1)} className="mr-3 text-xl"><i className="fa fa-arrow-left"></i></button>}
        <div className="flex items-center gap-3">
          <i className="fa fa-calculator text-3xl animate-pulse"></i>
          <h1 className="text-[clamp(1.2rem,3vw,2rem)] font-bold">四年级数学乐园</h1>
        </div>
        <Link to="/" className="bg-white text-primary px-4 py-2 rounded-full font-bold">首页</Link>
      </div>
    </header>
  );
}

// 首页（单元卡片 + 图标正常显示）
function Home() {
  return (
    <div className="container mx-auto px-4 py-12">
      <div className="text-center mb-10">
        <h2 className="text-[clamp(1.5rem,4vw,2.5rem)] font-bold text-dark mb-2">数学下册趣味小游戏</h2>
        <p className="text-gray-600">探索数学乐趣，轻松学习</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {unitList.map(unit => (
          <div key={unit.unitId} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:-translate-y-1 transition-all">
            {/* 单元图标（这里修复了！） */}
            <div className={`h-40 ${unit.unitColor} flex items-center justify-center`}>
              <i className={`fa ${unit.unitIcon} text-5xl text-primary`}></i>
            </div>

            <div className="p-6">
              <h3 className="text-xl font-bold mb-4">{unit.unitTitle}</h3>
              <div className="space-y-3">
                {unit.games.map(game => (
                  <div key={game.gameId} className={!game.isDone ? "opacity-60" : ""}>
                    {game.isDone ? (
                      <Link to={game.gamePath} className="flex items-center text-primary font-bold">
                        <i className="fa fa-gamepad mr-2"></i> {game.gameTitle}
                        <span className="ml-2 bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">已完成</span>
                      </Link>
                    ) : (
                      <div className="flex items-center text-gray-400 font-bold">
                        <i className="fa fa-lock mr-2"></i> {game.gameTitle}
                        <span className="ml-2 bg-yellow-100 text-yellow-800 text-xs px-2 py-1 rounded-full">待加入</span>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// 游戏页面
function GamePage({ src }) {
  return (
    <div className="container mx-auto px-4 py-8">
      <iframe src={src} className="w-full min-h-[85vh] border-0 rounded-xl shadow-xl" />
    </div>
  );
}